// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"8087":"de921b3e","8602":"ba7db96d"}[chunkId] || chunkId) + "." + {"1462":"aa74dbfbd8d04744","2813":"f56bb47ed11159a1","5374":"82f16d27486ff640","8047":"53d26f153f78bd3a","8087":"c5faf9a5ea664d79","8602":"e4b646737cebfc18"}[chunkId] + ".js";
};